export const SLIDER_CLICK_GUARD_PX = 10

export function exceedsClickGuard(
  dx: number,
  dy: number,
  threshold = SLIDER_CLICK_GUARD_PX,
): boolean {
  return Math.hypot(dx, dy) > threshold
}

export function horizontalSwipeDir(
  dx: number,
  dy: number,
  minSwipe: number,
): 'next' | 'prev' | null {
  const absX = Math.abs(dx)
  const absY = Math.abs(dy)
  if (absX < minSwipe) return null
  if (absY > absX * 1.75 && absY > 24) return null
  return dx < 0 ? 'next' : 'prev'
}
